(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mug-personalization"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mug-photo-input]').forEach((input) => {
  input.addEventListener('change', () => {
    const preview = document.getElementById(input.dataset.previewTarget);
    const image = preview?.querySelector('[data-mug-preview-image]');
    const name = preview?.querySelector('[data-mug-preview-name]');
    const file = input.files?.[0];
    if (!preview || !image || !name) return;
    if (!file) {
      preview.hidden = true;
      image.removeAttribute('src');
      name.textContent = '';
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    image.src = objectUrl;
    image.addEventListener('load', () => URL.revokeObjectURL(objectUrl), { once: true });
    name.textContent = file.name;
    preview.hidden = false;
  });
});
  } catch(e) { console.error(e); }
})();

})();
